/* OSCIRA EMS — minimal, dependency-free. Cart/variant stay on the theme's product-form. */
(function () {
  'use strict';
  // every OSCIRA section includes this file; run the setup only once per page
  if (window.__osciraEmsInit) return;
  window.__osciraEmsInit = true;

  /* Hero gallery: thumbnails, arrows, swipe */
  document.querySelectorAll('.oscira-ems .oe-hero').forEach(function (hero) {
    var main = hero.querySelector('.oe-hero__img');
    var stage = hero.querySelector('.oe-hero__stage');
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('.oe-hero__thumb'));
    if (!main || thumbs.length < 2) return;
    // srcset would keep showing the first photo, so the gallery drives src alone
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    var idx = Math.max(0, thumbs.findIndex(function (b) { return b.classList.contains('is-on'); }));
    var count = stage && stage.querySelector('[data-gal-count]');

    /* slide transition: the old photo is pushed out in the swipe direction while the new one comes in */
    var seq = 0, curSlide = null, leftover = null;
    function setBg(src) { if (stage) stage.style.setProperty('--oe-bg', 'url("' + src + '")'); }
    function slideTo(src, dir) {
      if (curSlide) { curSlide(); curSlide = null; }
      if (leftover) { leftover.remove(); leftover = null; }
      var tok = ++seq; setBg(src);
      if (!dir || !main.animate || !stage || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { main.src = src; return; }
      var inc = new Image();
      inc.className = main.className; inc.alt = ''; inc.setAttribute('aria-hidden', 'true');
      inc.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none';
      inc.src = src;
      (inc.decode ? inc.decode() : Promise.resolve()).catch(function () {}).then(function () {
        if (tok !== seq) return;
        if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
        stage.style.overflow = 'hidden';
        stage.insertBefore(inc, main.nextSibling);
        var o = { duration: 340, easing: 'cubic-bezier(.22,.8,.3,1)', fill: 'both' };
        var a1 = main.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-dir * 100) + '%)' }], o);
        var a2 = inc.animate([{ transform: 'translateX(' + (dir * 100) + '%)' }, { transform: 'translateX(0)' }], o);
        var done = false;
        function end() {
          if (done) return; done = true;
          main.src = src; a1.cancel(); a2.cancel();
          leftover = inc;
          var rm = function () { if (leftover === inc) leftover = null; inc.remove(); };
          (main.decode ? main.decode() : Promise.resolve()).catch(function () {}).then(rm);
        }
        curSlide = end;
        a2.onfinish = function () { end(); if (curSlide === end) curSlide = null; };
      });
    }

    function go(i, dh) {
      var old = idx; idx = (i + thumbs.length) % thumbs.length;
      var full = thumbs[idx].getAttribute('data-full');
      if (full) slideTo(full, idx === old ? 0 : (dh || (idx > old ? 1 : -1)));
      thumbs.forEach(function (b, n) { b.classList.toggle('is-on', n === idx); });
      var tp = thumbs[idx].parentNode; /* scroll only the thumbnail strip, never the page */
      if (tp && tp.scrollBy) { var cr = tp.getBoundingClientRect(), tr = thumbs[idx].getBoundingClientRect(); var sdy = tr.top < cr.top ? tr.top - cr.top : (tr.bottom > cr.bottom ? tr.bottom - cr.bottom : 0); var sdx = tr.left < cr.left ? tr.left - cr.left : (tr.right > cr.right ? tr.right - cr.right : 0); if (sdx || sdy) tp.scrollBy({ left: sdx, top: sdy, behavior: 'smooth' }); }
      if (count) count.textContent = (idx + 1) + ' / ' + thumbs.length;
      var pre = new Image(); pre.src = thumbs[(idx + 1) % thumbs.length].getAttribute('data-full');
    }
    thumbs.forEach(function (btn, n) { btn.addEventListener('click', function () { go(n); }); });

    if (stage) {
      var prev = stage.querySelector('[data-gal-prev]'), next = stage.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1, -1); });
      if (next) next.addEventListener('click', function () { go(idx + 1, 1); });
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        x0 = null;
      });
    }
    /* Tap-to-enlarge: lightbox viewer + a faint hint on the main photo */
    (function () {
      if (!stage || !thumbs.length || document.querySelector('.oe-lb')) return;
      var touch = window.matchMedia && matchMedia('(hover: none)').matches;
      if (!document.getElementById('oe-lb-style')) {
        var st = document.createElement('style'); st.id = 'oe-lb-style';
        st.textContent = [
          '.oe-zoomhint{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:3;display:flex;flex-direction:column;align-items:center;gap:7px;padding:13px 18px 12px;border-radius:18px;background:rgba(53,26,43,.36);color:rgba(255,255,255,.9);font-family:inherit;font-size:13px;font-weight:600;letter-spacing:.02em;line-height:1.2;white-space:nowrap;pointer-events:none;transition:opacity .5s}',
          '.oe-zoomhint.is-off{opacity:0}',
          '.oe-zoomhint svg{width:30px;height:30px;animation:oeTap 1.9s ease-in-out infinite}',
          '@keyframes oeTap{0%,55%,100%{transform:translateY(0) scale(1)}25%{transform:translateY(-5px) scale(1)}40%{transform:translateY(1px) scale(.92)}}',
          '@media (prefers-reduced-motion:reduce){.oe-zoomhint svg{animation:none}}',
          '.oe-lb{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(26,10,20,.95);opacity:0;visibility:hidden;transition:opacity .2s,visibility .2s}',
          '.oe-lb.is-open{opacity:1;visibility:visible}',
          '.oe-lb__stage{display:flex;max-width:100vw;max-height:100vh;overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}',
          '.oe-lb__img{display:block;margin:auto;flex:none;width:min(96vw,88vh);max-width:none;height:auto;cursor:zoom-in;border-radius:10px;background:#fff;transition:opacity .18s;user-select:none;-webkit-user-select:none}',
          '.oe-lb.is-zoom .oe-lb__img{cursor:zoom-out;border-radius:0}',
          '.oe-lb__x,.oe-lb__nav{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center;width:46px;height:46px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.16);color:#fff;cursor:pointer}',
          '.oe-lb__x{top:14px;right:14px}',
          '.oe-lb__nav{top:50%;margin-top:-23px}',
          '.oe-lb__prev{left:12px}',
          '.oe-lb__next{right:12px}',
          '.oe-lb__x svg,.oe-lb__nav svg{width:22px;height:22px}',
          '.oe-lb__count{position:absolute;left:0;right:0;bottom:16px;z-index:2;text-align:center;color:rgba(255,255,255,.82);font-family:inherit;font-size:13px;font-weight:600;line-height:1.5;pointer-events:none;text-shadow:0 1px 6px rgba(0,0,0,.5)}',
          '.oe-lb__tip{font-weight:500;opacity:.8}'
        ].join('');
        document.head.appendChild(st);
      }
      var n = thumbs.length, li = 0, zoomed = false, lastFocus = null;
      var lb = document.createElement('div');
      lb.className = 'oe-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Photo viewer');
      var ar = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
      lb.innerHTML = '<button type="button" class="oe-lb__x" aria-label="Close">' + ar('M6 6l12 12M18 6L6 18') + '</button>'
        + '<button type="button" class="oe-lb__nav oe-lb__prev" aria-label="Previous photo">' + ar('M15 18l-6-6 6-6') + '</button>'
        + '<div class="oe-lb__stage"><img class="oe-lb__img" alt=""></div>'
        + '<button type="button" class="oe-lb__nav oe-lb__next" aria-label="Next photo">' + ar('M9 18l6-6-6-6') + '</button>'
        + '<div class="oe-lb__count"><span class="oe-lb__n"></span><br><span class="oe-lb__tip">Tap the photo to zoom</span></div>';
      document.body.appendChild(lb);
      var box = lb.querySelector('.oe-lb__stage'), im = lb.querySelector('.oe-lb__img'), num = lb.querySelector('.oe-lb__n');
      var seen = false; try { seen = sessionStorage.getItem('oeZoomSeen') === '1'; } catch (e) {}
      var hint = null;
      if (!seen) {
        hint = document.createElement('div'); hint.className = 'oe-zoomhint'; hint.setAttribute('aria-hidden', 'true');
        hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 14a8 8 0 0 1-8 8"/><path d="M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2"/><path d="M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1"/><path d="M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10"/><path d="M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg><span>' + (touch ? 'Tap' : 'Click') + ' to enlarge</span>';
        stage.appendChild(hint);
      }
      function big(i) { return (thumbs[i].getAttribute('data-full') || '').replace(/width=\d+/, 'width=2000'); }
      function setZoom(on) {
        zoomed = on; lb.classList.toggle('is-zoom', on);
        if (on) {
          var w = im.getBoundingClientRect().width; im.style.width = Math.round(w * 2.4) + 'px';
          box.scrollLeft = (box.scrollWidth - box.clientWidth) / 2; box.scrollTop = (box.scrollHeight - box.clientHeight) / 2;
        } else { im.style.width = ''; }
      }
      function show(i) {
        li = (i + n) % n; setZoom(false);
        im.style.opacity = 0; im.onload = function () { im.style.opacity = 1; };
        im.src = big(li); if (im.complete && im.naturalWidth) im.style.opacity = 1;
        num.textContent = (li + 1) + ' / ' + n;
        var pre = new Image(); pre.src = big((li + 1) % n);
      }
      function open() {
        lastFocus = document.activeElement; show(idx);
        lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
        lb.querySelector('.oe-lb__x').focus({ preventScroll: true });
        if (hint) { hint.classList.add('is-off'); try { sessionStorage.setItem('oeZoomSeen', '1'); } catch (e) {} }
      }
      function close() {
        lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; setZoom(false);
        if (li !== idx) go(li);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      lb.querySelector('.oe-lb__x').addEventListener('click', close);
      lb.querySelector('.oe-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); show(li - 1); });
      lb.querySelector('.oe-lb__next').addEventListener('click', function (e) { e.stopPropagation(); show(li + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === box) close(); });
      im.addEventListener('click', function () { setZoom(!zoomed); });
      var sx = null, sy = null;
      box.addEventListener('touchstart', function (e) { if (e.touches.length > 1) { sx = null; return; } sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null || zoomed) { sx = null; return; }
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(li + (dx < 0 ? 1 : -1));
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(li - 1); else if (e.key === 'ArrowRight') show(li + 1);
      });
      stage.style.cursor = 'zoom-in'; stage.setAttribute('role', 'button'); stage.setAttribute('tabindex', '0'); stage.setAttribute('aria-label', 'Enlarge photo');
      stage.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('button')) return; open(); });
      stage.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === stage) { e.preventDefault(); open(); } });
    })();
    go(idx);
  });

  /* Mobile sticky cart: show once the hero CTA scrolls out of view */
  var sticky = document.querySelector('.oscira-ems-sticky');
  var heroCta = document.querySelector('.oscira-ems .oe-hero__cta');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    // hide the floating bar while the hero buy button or the in-page purchase bar is on screen
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      sticky.classList.toggle('is-on', seen.size === 0);
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(heroCta);
    document.querySelectorAll('.oe-pbar').forEach(function (el) { io.observe(el); });
  } else if (sticky && heroCta) {
    window.addEventListener('scroll', function () {
      var r = heroCta.getBoundingClientRect();
      sticky.classList.toggle('is-on', r.bottom < 0);
    }, { passive: true });
  }

  /* Sticky "Add to cart" simply forwards the click to the real hero form button */
  document.querySelectorAll('[data-forward-cta]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var realBtn = document.querySelector('.oscira-ems .oe-hero__form [type="submit"], .oscira-ems .oe-hero__form button[name="add"]');
      if (realBtn) { e.preventDefault(); realBtn.click(); }
    });
  });

  /* Hero purchase controller — pack (1/2/3) + size selection, live price with bundle savings.
     Real money is charged by Shopify: pack simply sets the line quantity; the % shown here must
     match the store's automatic quantity discounts. */
  document.querySelectorAll('.oscira-ems .oe-hero__form').forEach(function (form) {
    var vid = form.querySelector('.oe-vid');
    var qtyInput = form.querySelector('.oe-qty') || form.querySelector('[name="quantity"]');
    var priceNow = document.querySelector('.oscira-ems [data-price-now]');
    var priceWas = document.querySelector('.oscira-ems [data-price-was]');
    var priceSave = document.querySelector('.oscira-ems [data-price-save]');
    var priceEach = document.querySelector('.oscira-ems [data-price-each]');
    var packs = document.querySelector('.oscira-ems [data-packs]');
    var curr = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

    function fmt(v) {
      var whole = Math.abs(v - Math.round(v)) < 0.005;
      var symbol = {GBP:'£',CAD:'CA$',AUD:'A$'}[curr];
      try { return new Intl.NumberFormat('en', {style:'currency',currency:curr,minimumFractionDigits:whole?0:2,maximumFractionDigits:whole?0:2}).formatToParts(v).map(function(p){return p.type === 'currency' && symbol ? symbol : p.value;}).join(''); }
      catch(e) { return curr + ' ' + v.toFixed(2); }
    }
    function fmtSave(v) { return fmt(v); }
    function parseAmt(t) {
      if (!t) return 0;
      var n = parseFloat(String(t).replace(/[^0-9.,-]/g, '').replace(/,/g, ''));
      return isNaN(n) ? 0 : n;
    }

    var UNIT = parseAmt(priceNow ? priceNow.textContent : '');
    var wasText = priceWas && !priceWas.hidden ? priceWas.textContent.trim() : '';
    var hasCompare = packs ? packs.getAttribute('data-has-compare') === '1' : !!wasText;
    var compareMoney = packs ? packs.getAttribute('data-compare-money') : wasText;
    var packQty = 1, packOff = 0;

    function recalc() {
      if (!UNIT) return;
      // round per-unit to the currency's minor unit so "each × qty" always equals the shown total
      var minor = curr === 'JPY' ? 1 : 100;
      var perUnit = Math.round(UNIT * (1 - packOff / 100) * minor) / minor;
      var total = perUnit * packQty;
      if (priceNow) priceNow.textContent = fmt(total);
      document.querySelectorAll('.oscira-ems-sticky .px b').forEach(function(el){el.textContent=fmt(total);var sx=el.parentNode.querySelector('s');if(sx&&hasCompare)sx.textContent=fmt(parseAmt(compareMoney));});
      document.querySelectorAll('.oe-pbar__price').forEach(function(el){el.setAttribute('translate','no');el.textContent=fmt(total);if(hasCompare){var s=document.createElement('s');s.textContent=' '+fmt(packQty>1?UNIT*packQty:parseAmt(compareMoney));el.appendChild(s);}});
      if (priceWas) {
        if (packQty > 1) { priceWas.textContent = fmt(UNIT * packQty); priceWas.hidden = false; }
        else if (hasCompare) { priceWas.textContent = fmt(parseAmt(compareMoney)); priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }
      if (priceSave) {
        if (packQty > 1) { priceSave.textContent = 'Save ' + packOff + '%'; priceSave.hidden = false; }
        else if (hasCompare) {
          var c = parseAmt(compareMoney);
          if (c > UNIT) { priceSave.textContent = 'Save ' + fmtSave(c - UNIT); priceSave.hidden = false; }
          else priceSave.hidden = true;
        } else priceSave.hidden = true;
      }
      if (priceEach) {
        if (packQty > 1) { priceEach.textContent = fmt(perUnit) + ' each'; priceEach.hidden = false; }
        else priceEach.hidden = true;
      }
      if (qtyInput) qtyInput.value = packQty;
      if (packs) {
        packs.querySelectorAll('.oe-pack').forEach(function (p) {
          var q = +p.getAttribute('data-qty'), o = +p.getAttribute('data-off');
          var pe = p.querySelector('[data-pack-each]');
          if (pe) pe.textContent = fmt(UNIT * (1 - o / 100)) + (q > 1 ? '/ea' : '');
        });
      }
    }

    if (packs) {
      packs.querySelectorAll('.oe-pack').forEach(function (p) {
        p.addEventListener('click', function () {
          packQty = +p.getAttribute('data-qty') || 1;
          packOff = +p.getAttribute('data-off') || 0;
          packs.querySelectorAll('.oe-pack').forEach(function (x) { x.classList.toggle('is-on', x === p); });
          var r = p.querySelector('input[type="radio"]'); if (r) r.checked = true;
          recalc();
        });
      });
    }

    form.querySelectorAll('.oe-size__b').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hasAttribute('disabled')) return;
        if (vid) vid.value = b.getAttribute('data-vid');
        form.querySelectorAll('.oe-size__b').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
      });
    });

    recalc();
  });

  /* Target-zone tabs */
  document.querySelectorAll('.oscira-ems .oe-ztabs').forEach(function (tablist) {
    var scope = tablist.closest('.oe-zones__tabswrap') || document;
    tablist.querySelectorAll('.oe-ztab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var z = tab.getAttribute('data-z');
        tablist.querySelectorAll('.oe-ztab').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', String(on));
        });
        scope.querySelectorAll('.oe-zpanel').forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-z') === z);
        });
      });
    });
  });

  /* Size guide toggle */
  document.querySelectorAll('.oscira-ems .oe-size__guide').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = !panel.hasAttribute('hidden');
      if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); }
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* Lazy-load videos as they approach the viewport, with a scroll/resize fallback
     so a clip never stays blank even if IntersectionObserver misses it. */
  var lazyVids = Array.prototype.slice.call(document.querySelectorAll('.oscira-ems video[data-lazy-src]'));
  function loadVid(v) {
    var src = v.getAttribute('data-lazy-src');
    if (!src || v.src) return;
    v.src = src; v.load(); v.play().catch(function () {});
  }
  function loadNearby() {
    var margin = 600, vh = window.innerHeight || 800, pending = false;
    lazyVids.forEach(function (v) {
      if (v.src) return;
      var r = v.getBoundingClientRect();
      if (r.top < vh + margin && r.bottom > -margin) loadVid(v); else pending = true;
    });
    return pending;
  }
  if (lazyVids.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { loadVid(e.target); obs.unobserve(e.target); } });
      }, { rootMargin: '400px 0px' });
      lazyVids.forEach(function (v) { vio.observe(v); });
    }
    var onScroll = function () {
      if (!loadNearby()) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // initial pass (covers clips already near the viewport at load)
    loadNearby();
  }

  /* Size finder — height + weight -> recommended size, then auto-selects that variant */
  (function () {
    var ORDER = ['S', 'M', 'L', 'XL', 'XXL'];
    // size chart: height range (cm) and weight range (kg) per size
    var H_MIN = [150, 155, 160, 165, 168], H_MAX = [162, 167, 172, 175, 178];
    var W_MAX = [50, 60, 70, 80, 90];
    function setResult(el, html, ok) {
      if (!el) return;
      el.innerHTML = html;
      el.hidden = false;
      el.classList.toggle('is-ok', !!ok);
      el.classList.toggle('is-err', !ok);
    }
    function pickSizeButton(size) {
      var btns = Array.prototype.slice.call(document.querySelectorAll('.oscira-ems .oe-size__b'));
      if (!btns.length) return null;
      var start = ORDER.indexOf(size);
      var tryIdx = [start, start + 1, start + 2, start - 1, start - 2];
      for (var k = 0; k < tryIdx.length; k++) {
        var lbl = ORDER[tryIdx[k]];
        if (!lbl) continue;
        for (var j = 0; j < btns.length; j++) {
          if (btns[j].textContent.trim() === lbl && !btns[j].hasAttribute('disabled')) {
            btns[j].click();
            return lbl;
          }
        }
      }
      return null;
    }
    // keep size buttons in S, M, L, XL, XXL order regardless of variant order
    document.querySelectorAll('.oscira-ems .oe-size__btns').forEach(function (wrap) {
      var bs = Array.prototype.slice.call(wrap.querySelectorAll('.oe-size__b'));
      bs.sort(function (a, b) { var ia = ORDER.indexOf(a.textContent.trim()), ib = ORDER.indexOf(b.textContent.trim()); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
      bs.forEach(function (x) { wrap.appendChild(x); });
    });
    document.querySelectorAll('.oscira-ems [data-finder]').forEach(function (f) {
      var unit = 'in';
      var uh = f.querySelector('[data-unit-h]'), uw = f.querySelector('[data-unit-w]');
      var res = f.querySelector('[data-finder-result]');
      var mmax = parseFloat(f.getAttribute('data-mmax')) || 60;
      var lmax = parseFloat(f.getAttribute('data-lmax')) || 73;
      var tall = parseFloat(f.getAttribute('data-tall')) || 178;
      var petite = parseFloat(f.getAttribute('data-petite')) || 157;

      f.querySelectorAll('.oe-finder__unit').forEach(function (b) {
        b.addEventListener('click', function () {
          unit = b.getAttribute('data-unit');
          f.querySelectorAll('.oe-finder__unit').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (uh) uh.textContent = unit === 'cm' ? 'cm' : 'in';
          if (uw) uw.textContent = unit === 'cm' ? 'kg' : 'lb';
        });
      });

      function run() {
        var hv = parseFloat(f.querySelector('[data-finder-h]').value);
        var wv = parseFloat(f.querySelector('[data-finder-w]').value);
        if (!(hv > 0) || !(wv > 0)) { setResult(res, 'Enter your height and weight to see your size.', false); return; }
        var cm = unit === 'cm' ? hv : hv * 2.54;
        var kg = unit === 'cm' ? wv : wv * 0.45359;
        if (cm < 120 || cm > 220 || kg < 35 || kg > 200) { setResult(res, 'Please double-check your height and weight.', false); return; }
        // weight decides first, then height nudges one size up/down when it falls outside that size's range
        var i = 0;
        while (i < 4 && kg > W_MAX[i]) i++;
        if (cm > H_MAX[i] && i < 4) i++;
        else if (cm < H_MIN[i] && i > 0 && kg <= W_MAX[i - 1] + 2) i--;
        var size = ORDER[i];
        var extra = kg > W_MAX[4] ? ' XXL is our largest size and may feel snug.' : '';
        var picked = pickSizeButton(size);
        if (picked) {
          if (picked === size) setResult(res, 'Your recommended size: <strong>' + size + '</strong> — selected above.' + extra, true);
          else setResult(res, 'Your recommended size: <strong>' + size + '</strong>. It is currently unavailable, so we selected <strong>' + picked + '</strong>.' + extra, true);
        } else {
          setResult(res, 'Your recommended size: <strong>' + size + '</strong>.' + extra, true);
        }
      }
      var go = f.querySelector('[data-finder-go]');
      if (go) go.addEventListener('click', run);
      f.querySelectorAll('input').forEach(function (inp) {
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      });
    });
  })();

  /* Scroll-reveal motion — elements rise/fade in as they enter the viewport */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // auto-tag a few cross-section elements so they animate too
    document.querySelectorAll('.oscira-ems .oe-trust__item, .oscira-ems .oe-faq__item, .oscira-ems .oe-hero__gallery, .oscira-ems .oe-hero__buy').forEach(function (el) {
      el.classList.add('oe-reveal');
    });
    // richer motion: more elements, image zoom-in, side slides for 2-column panels
    document.querySelectorAll('.oscira-ems .oe-shead, .oscira-ems .oe-reviews__head, .oscira-ems .oe-review, .oscira-ems .oe-pbar__in, .oscira-ems .oe-vf__txt, .oscira-ems .oe-vf__v, .oscira-ems .oe-panel__head').forEach(function (el) {
      if (!el.closest('.oe-hero')) el.classList.add('oe-reveal');
    });
    document.querySelectorAll('.oscira-ems .oe-panel__media, .oscira-ems .oe-panel__imgwrap, .oscira-ems .oe-vf__v').forEach(function (el) { el.classList.add('oe-reveal--zoom'); });
    document.querySelectorAll('.oscira-ems .oe-panel:not(.oe-panel--full)').forEach(function (p) {
      var rev = p.classList.contains('oe-panel--rev');
      var txt = p.querySelector('.oe-panel__txt');
      if (txt) txt.classList.add(rev ? 'oe-reveal--right' : 'oe-reveal--left');
    });
    var targets = document.querySelectorAll('.oscira-ems .oe-reveal');
    if (!targets.length) return;
    // start hidden instantly (no fade-out flash), then re-enable transitions
    var root = document.documentElement;
    root.classList.add('oe-anim-pre', 'oe-anim');
    void root.offsetHeight;
    root.classList.remove('oe-anim-pre');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // stagger siblings within a shared parent for a nicer cascade
    var rio = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.classList && c.classList.contains('oe-reveal'); });
        var idx = sibs.indexOf(el);
        if (idx > 0) el.style.transitionDelay = Math.min(idx, 4) * 90 + 'ms';
        el.classList.add('is-in');
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { rio.observe(el); });
  })();

  /* FAQ accordion (used by the FAQ section, Priority B) */
  document.querySelectorAll('.oscira-ems .oe-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.oe-faq__item');
      if (!item) return;
      var open = item.classList.contains('is-open');
      item.classList.toggle('is-open', !open);
      q.setAttribute('aria-expanded', String(!open));
    });
  });

  /* Mobile: tap a panel image to view it full screen (text baked into images is tiny on phones) */
  (function () {
    return; // disabled: section images are not interactive
    var imgs = document.querySelectorAll('.oscira-ems .oe-panel__img');
    if (!imgs.length) return;
    var box = document.createElement('div');
    box.className = 'oe-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.hidden = true;
    box.innerHTML = '<button type="button" class="oe-zoom__close" aria-label="Close">&times;</button><div class="oe-zoom__scroll"><img alt=""></div><p class="oe-zoom__hint">Pinch or scroll to see the whole image</p>';
    document.body.appendChild(box);
    var big = box.querySelector('img'), closeBtn = box.querySelector('.oe-zoom__close'), last = null;
    function close() { box.hidden = true; document.documentElement.classList.remove('oe-zoom-open'); if (last) last.focus(); }
    closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
    imgs.forEach(function (im) {
      var wrap = im.parentElement;
      wrap.classList.add('oe-zoomable');
      wrap.setAttribute('role', 'button');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', 'Enlarge image');
      function open() {
        if (window.innerWidth >= 750) return;
        last = wrap;
        big.src = im.currentSrc || im.src;
        big.alt = im.alt || '';
        box.hidden = false;
        document.documentElement.classList.add('oe-zoom-open');
        box.querySelector('.oe-zoom__scroll').scrollLeft = 0;
        closeBtn.focus();
      }
      wrap.addEventListener('click', open);
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  })();

  /* Mobile: fold the size finder into a tap-to-open row to shorten the purchase area */
  (function () {
    var finders = document.querySelectorAll('.oscira-ems [data-finder]');
    finders.forEach(function (f) {
      var title = f.querySelector('.oe-finder__title');
      if (!title) return;
      f.classList.add('oe-finder--fold');
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = !f.classList.contains('is-open');
        f.classList.toggle('is-open', open);
        title.setAttribute('aria-expanded', String(open));
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
    // "Find your size" mentioned in the size guide opens the finder
    document.querySelectorAll('.oscira-ems .oe-size__guide').forEach(function (b) {
      b.addEventListener('click', function () {
        finders.forEach(function (f) { if (!f.classList.contains('is-open')) { f.classList.add('is-open'); var t = f.querySelector('.oe-finder__title'); if (t) t.setAttribute('aria-expanded', 'true'); } });
      });
    });
  })();
})();

/* Coupon LP: line the bottom of the photo panel up with the bottom of the purchase box (desktop, two columns) */
(function () {
  function align() {
    if (!document.querySelector('.oscira-lp')) return;
    var hero = document.querySelector('.oscira-ems .oe-hero');
    if (!hero) return;
    var media = hero.querySelector('.oe-hero__media'), form = hero.querySelector('.oe-hero__form');
    if (!media || !form) return;
    media.classList.remove('oe-fill'); media.style.height = ''; media.style.boxSizing = '';
    var fr = form.getBoundingClientRect(), mr = media.getBoundingClientRect();
    if (window.innerWidth < 750 || mr.left < fr.right - 10 || !fr.height) return;
    var pos = media.style.position; media.style.position = 'static';
    var top = media.getBoundingClientRect().top, nat = media.getBoundingClientRect().height;
    var bottom = form.getBoundingClientRect().bottom;
    media.style.position = pos;
    var target = Math.round(bottom - top);
    if (target < nat * 0.8 || target > nat * 1.6) return;
    media.classList.add('oe-fill'); media.style.boxSizing = 'border-box'; media.style.height = target + 'px';
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(align, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', align); else align();
  window.addEventListener('load', soon);
  window.addEventListener('resize', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(soon);
  if (window.ResizeObserver) {
    var info = document.querySelector('.oscira-ems .oe-hero__info');
    if (info) new ResizeObserver(soon).observe(info);
  }
  document.addEventListener('shopify:section:load', soon);
})();

/* back-to-top button (bottom right, always available after scrolling) */
(function(){try{
if(window.__oeTop)return;window.__oeTop=1;
var st=document.createElement('style');st.id='oe-top-style';
st.textContent='.oe-top{position:fixed;right:14px;bottom:var(--oe-top-b,16px);z-index:39;width:46px;height:46px;border-radius:50%;border:2px solid #FAC654;background:#351A2B;color:#EDCCBE;display:flex;align-items:center;justify-content:center;padding:0;margin:0;cursor:pointer;box-shadow:0 4px 14px rgba(53,26,43,.35);opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity .25s,transform .25s,visibility .25s;-webkit-tap-highlight-color:transparent}.oe-top.is-on{opacity:1;visibility:visible;transform:none}.oe-top svg{width:20px;height:20px;display:block}.oe-top:focus-visible{outline:3px solid #FAC654;outline-offset:3px}@media(min-width:750px){.oe-top{right:24px;width:50px;height:50px}}@media(prefers-reduced-motion:reduce){.oe-top{transition:none}}';
document.head.appendChild(st);
var b=document.createElement('button');b.type='button';b.className='oe-top';b.setAttribute('aria-label','Back to top');
b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 11.5l7-7 7 7"/></svg>';
document.body.appendChild(b);
var tk=0,reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function upd(){tk=0;var y=window.pageYOffset||document.documentElement.scrollTop||0;b.classList.toggle('is-on',y>600);var s=document.getElementById('oscira-ems-sticky'),h=0;if(s&&getComputedStyle(s).display!=='none'){h=Math.max(0,window.innerHeight-s.getBoundingClientRect().top);}b.style.setProperty('--oe-top-b','calc('+(Math.round(h)+16)+'px + env(safe-area-inset-bottom,0px))');}
function sched(){if(!tk){tk=1;requestAnimationFrame(upd);}}
window.addEventListener('scroll',sched,{passive:true});window.addEventListener('resize',sched);window.addEventListener('pageshow',sched);
b.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});b.blur();});
upd();
}catch(e){}})();
